module.exports = __webpack_public_path__ + "static/face-morphing-b631ce339a790750a488d03aeb9bfe67.gif";